import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const SuccessModal = ({
    open,
    setClose,
    crop,
    fieldId,
}: {
    open: boolean;
    setClose: () => void;
    crop: string;
    fieldId: number;
}) => {
    const navigate = useNavigate();
    return (
        <ModalV2
            open={open}
            onClose={setClose}
            title={_('¡Cultivo cargado con éxito!')}
            bodyProps={{ spacing: 3, alignItems: 'flex-start' }}
            actions={
                <Button
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                        navigate(reverse('fields.FieldDetail', { params: { fieldId: fieldId } }));
                        setClose();
                    }}
                    data-testid='field-monitoring-creation-dialog-go-to-field-detail-button'
                >
                    {_('Ir al detalle del lote')}
                </Button>
            }
            actionsProps={{ sx: { justifyContent: 'flex-end' } }}
        >
            <Typography variant='body1' color='primary'>
                {crop === 'corn'
                    ? _(
                          'Ahora podés seguir la evolución de tu cultivo de maíz desde la emergencia hasta la cosecha, con acumulación de GDUs reales.'
                      )
                    : _('El cultivo ya está registrado en tu lote. Podés hacerle seguimiento durante toda la campaña.')}
            </Typography>
        </ModalV2>
    );
};

export default SuccessModal;
